<template>
    <div class="link-container">
        <div class="steps-container">
            <!-- 步骤1 -->
            <div class="step-item" v-for="item in steps" :key="item.id">
                <div class="step-number">{{item.id}}</div>
                <div class="step-content">
                    <p class="step-text">{{item.text}}</p>
                </div>
            </div>
             <div class="image-container">
                <span style="color:#17C2CF;margin:10px 0;font-size:14px;">示例截图（红某书）</span>
                <img src="../assets/signIn/linkGuidance.png" alt="" class="guidance-image">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Link',
    data() {
        return {
            steps: [
                {
                    id: 1,
                    text: '打开发布作品的 App，点击右下角【我】进入主页进入刚刚发布的作品详情，点击"..."或"分享"按钮'
                },
                {
                    id: 2,
                    text: '在底部弹窗中找到"复制链接"按钮，点击"复制链接"'
                },
                {
                    id: 3,
                    text: '回到窝窝投APP-打开任务详情-上传发布链接:粘贴链接至输入框。'
                }
            ]
        }
    },
    mounted() {

    },
    methods: {
    }
}
</script>

<style lang="less" scoped>
.link-container {
    padding: 20px;
    display: flex;
    flex-direction: column;
    .steps-container {
        .step-item {
            padding: 10px 5px;
            display: flex;
            // align-items: flex-start;

            .step-number {
                width: 20px;
                height: 16px;
                background: #17C2CF;
                color: #fff;
                align-items: center;
                font-size: 14px;
                margin-right: 16px;
                margin-top:3px;
                border-radius: 2px;
                text-align: center;
                line-height: 16px;
            }

            .step-content {
                flex: 1;

                .step-text {
                    color: #000000;
                    font-size: 14px;
                    margin: 0;
                    font-weight: 400;
                }
            }
        }
        .image-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            margin-top: 20px;
            background-color: #F7F8FC;
            .guidance-image {
                width: 85%;
                height: auto;
                max-width: 85%;
                object-fit: contain;
                display: block;
                margin:0 auto;

            }
        }
    }
}

</style>
